
<template>
  <transition name="fade" @enter="enter" appear>
    <div v-if="this.scenes.loading">
      <div class="scene-wrap loading-wrap">
        <img class="loading-img" src="images/loading_fit.gif" alt="" />
      </div>
    </div>
  </transition>
</template>

<script>
import anime from "animejs";

export default {
  name: "Loading",
  props: ["isLoading", "scenes", "currentScene", "isDebug", "isTest"],
  created() {
    //start preload
    // console.log("- Loading -");
  },
  mounted() {
    // this.emitter.on("finish-loading", () => {
    //   this.emitter.emit("hide-loading");
    //   console.log("[loading] show scene");
    // });
  },
  methods: {
    enter() {
      var time = 8000;
      if (this.isDebug || this.isTest ) {
        time = 1000;
      }
      // console.log("Loading time: " + time);
      //2. fade out
      var load_tl = anime.timeline({
        autoplay: true,
      });
      console.log("[Loading] time: "+time);
      load_tl.add({
        duration: time,
        complete: function () {
          // console.log("loading timeline");
          // if (!this.isLoading) {
            this.emitter.emit("hide-loading");
          // }
        }.bind(this),
      });
    },
  },
};
</script>

